import { getLocalTimeZone, today } from "@internationalized/date";
export const getDefaultMonth = () => {
    const now = today(getLocalTimeZone());
    return `${now.year}-${String(now.month).padStart(2, "0")}`;
};
export const splitAmNames = (am) => !am || am.trim() === "" || am === "NA" ? ["NA"] : am.split(",").map(s => s.trim()).filter(Boolean);
export const getInitials = (name = "") => name.trim().split(/\s+/).filter(Boolean).map(n => n[0]).join("").toUpperCase();
